import {
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
import { FullWidthModalProps } from './interface'

const FullWidthModal: React.FC<FullWidthModalProps> = ({
  title,
  children,
  ...props
}) => {
  return (
    <Modal size="full" {...props}>
      <ModalOverlay />
      <ModalContent bgColor="#fafafa" justifyContent="space-between" h="100%">
        <ModalHeader
          backgroundColor="#fff"
          boxShadow="0px 1px 1px rgba(0, 0, 0, 0.07), 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 4px 10px rgba(0, 0, 0, 0.05)"
          zIndex={1}
          border="none"
        >
          <Heading as="h3" fontSize="1.3rem">
            {title}
          </Heading>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody
          p="0"
          flex={1}
          overflow="hidden"
          sx={{
            form: {
              height: '100%',
            },
          }}
        >
          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default FullWidthModal
